import { Spinner } from "@phosphor-icons/react";

export function Loading() {
  return (
    <div className="flex size-full items-center justify-center">
      <Spinner className="text-primary-600 animate-spin" size={30} />
    </div>
  );
}

export default Loading;
